export class Auth0User {
  email: string;
  password: string;
  tenantName: string;
  tenantBaseWebUrl: string;
  hasExpired: boolean;

  static parse(data): Auth0User {
    if (!data) return;

    var auth0User = new Auth0User();
    auth0User.email = data.email;
    auth0User.tenantName = data.tenantName;
    auth0User.tenantBaseWebUrl = data.tenantBaseWebUrl;
    auth0User.hasExpired = data.hasExpired;
    return auth0User;
  }
}
